import { render, staticRenderFns } from "./ed-document-to-split-object.vue?vue&type=template&id=9f1e6e26&scoped=true&"
import script from "./ed-document-to-split-object.ts?vue&type=script&lang=ts&"
export * from "./ed-document-to-split-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-document-to-split-object.scss?vue&type=style&index=0&id=9f1e6e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1e6e26",
  null
  
)

export default component.exports